export default "./86b5767fd7a0def38701fe6d750b16f8.svg";